export const getCurrentTimeInGMT9 = () => {
  const date = new Date(new Date().toUTCString());
  date.setHours(date.getHours() + 9);
  return new Date(date.toISOString().split('T')[0]);
};

export function normalizeDate(date: Date) {
  const month = date.getMonth() + 1;
  const monthStr = month < 10 ? `0${month}` : month;
  const day = date.getDate();
  const dayStr = day < 10 ? `0${day}` : day;
  return `${date.getFullYear()}-${monthStr}-${dayStr}`;
}

const weekdayName = ['日', '月', '火', '水', '木', '金', '土'];

export const formatDate = (date: Date) => {
  return `令和　${date.getFullYear() - 2018}年${date.getMonth() + 1}月${date.getDate()}日（${weekdayName[date.getDay()]}）`;
}

export const EXPENSE_CATEGORIES = ['food', 'transportation', 'entertainment', 'shopping', 'bills', 'other'] as const;
